import axios from 'axios';
import config from "../app.config";

export var passwordService;
export default passwordService = {
    forgotPassword,
    checkKeyInitPassword,
    changePasswordForgot,
    changePassword,
}

async function forgotPassword(data) {
    return await axios.post(`${config.LOCAL_API_URL}/forgot-password`, data)
        .then(response => {
            if (response.data && response.data.status) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function checkKeyInitPassword(data) {
    return await axios.get(`${config.LOCAL_API_URL}/password/init/${data}`)
        .then(response => {
            if (response.data && response.data.status ) {
                // console.log('response service')
                // console.log(response)
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function changePasswordForgot(data) {
    return await axios.post(`${config.LOCAL_API_URL}/password/init`, data)
        .then(response => {
            if (response.data && response.data.status) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}
async function changePassword(data) {
    return await axios.post(`${config.LOCAL_API_URL}/password/setPassword`, data)
        .then(response => {
            if (response.data && response.data.status) {
                return Promise.resolve(response.data);
            } else {
                return Promise.resolve(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}